var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1061 14.085L22.5344 10.9924C22.8221 10.8281 23 10.5234 23 10.1965V4.01116C23 3.68419 22.8221 3.37956 22.5344 3.21527L17.1061 0.122612C16.8183 -0.0416675 16.4611 -0.0400715 16.175 0.122612L10.7466 3.21527C10.4589 3.37956 10.2811 3.68419 10.2811 4.01116V15.0643L6.47417 17.2319L2.66725 15.0643V10.7276L6.47417 8.56007L8.98468 9.99069V7.08147L6.9397 5.91556C6.79905 5.83582 6.63748 5.79275 6.47417 5.79275C6.31086 5.79275 6.14929 5.83582 6.00864 5.91556L0.580311 9.00821C0.292568 9.1725 0.114746 9.47718 0.114746 9.80413V15.9895C0.114746 16.3164 0.292568 16.621 0.580311 16.7853L6.00864 19.878C6.29633 20.0407 6.65201 20.0407 6.9397 19.878L12.368 16.7853C12.6558 16.621 12.8336 16.3164 12.8336 15.9895V4.93466L12.9015 4.89637L16.6389 2.76708L20.4459 4.93466V9.27141L16.6389 11.439L14.1316 10.0114V12.9207L16.1733 14.0835C16.4611 14.2461 16.8183 14.2461 17.1045 14.0835L17.1061 14.085Z",
    fill: "url(#paint0_linear_21782_6331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21782_6331",
    x1: 0.0403842,
    y1: 16.5955,
    x2: 21.8674,
    y2: 3.75515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A726C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPolygon);
export default __webpack_public_path__ + "static/media/new-polygon.10d1973653af875a0ee2dc984d88504b.svg";
export { ForwardRef as ReactComponent };